import { useNotificationStore } from '@dashboard/stores/notificationStore'
export const capitalize = (x: string) => {
  if (x && x.length) {
    const firstLetterIndex = x.search(/[a-zA-Z]/)
    if (firstLetterIndex !== -1) {
      return x.slice(0, firstLetterIndex) + x.charAt(firstLetterIndex).toUpperCase() + x.slice(firstLetterIndex + 1)
    }
  }
  return x
}

export const singularize = (x: string) => (x.endsWith('s') ? x.slice(0, -1) : x)

export const pluralize = (n: number, singular: string, plural: string) => n + ' ' + (n === 1 ? singular : plural)

export const sluggify = (x: string) => x.toLowerCase().replace(/ /g, '-')

export const toSnakeCase = (x: string) =>
  x
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')

export const stripHtml = (x: string | null) => {
  if (!x) {
    return ''
  }
  const div = document.createElement('div')
  div.innerHTML = x
  return div.innerText ?? div.textContent ?? ''
}

export const experienceLabel = (name: string | null | undefined) =>
  stripHtml(name?.replace(/<br\b[^>]*>|<\/(?:p|div|li|h[1-6]|tr|blockquote)>/gi, ' ') ?? null)
    .replace(/\s+/g, ' ')
    .trim()

export const toSentence = (x: string[]) => {
  if (x.length === 1) {
    return x[0]
  }
  return x.slice(0, -1).join(', ') + ' and ' + x[x.length - 1]
}

const copyUsingTextArea = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()

  try {
    return document.execCommand?.('copy') === true
  } catch {
    return false
  } finally {
    textArea.remove()
  }
}

export const copyToClipboard = async (text: string, successMessage = 'Copied to clipboard') => {
  const notificationStore = useNotificationStore()
  let copied = false

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      copied = true
    } catch {
      copied = false
    }
  }

  if (!copied) {
    copied = copyUsingTextArea(text)
  }

  if (copied) {
    notificationStore.addNotification(successMessage)
  } else {
    notificationStore.addError('Unable to copy to clipboard')
  }

  return copied
}
